// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"mr-z","giftOrPromoSelector":"nr-z","disabled":"or-z","subTitle":"pr-z","selectShipAddressMessage":"qr-z","changePayment":"rr-z"};